import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
const TextStyle = styled.div`
  color: ${props => props.color};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  text-align: ${props => props.center ? 'center' : null};
  font-size: 0.9375rem;
  line-height: 1.375rem;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${breakpoints.md} {
    font-size: 1.125rem;
    line-height: 2rem;
  }

  ${breakpoints.lg} {
    font-size: 1.25rem;
    line-height: 2rem;
  }

  blockquote {
    font-size: 1.75rem;
    color: ${({
  theme
}) => theme.base.black};
    line-height: 1.6;
    border-left: 3px solid ${({
  theme
}) => theme.primary.main};
    padding-left: 15px;

    ${breakpoints.md} {
      font-size: 2rem;
      padding-left: 22px;
    }
  }

  a {
    color: ${({
  theme
}) => theme.primary.main};
    text-decoration: underline;

    &:hover {
      color: ${({
  theme
}) => theme.primary.light};
    }
  }

  ol {
    color: ${({
  theme
}) => theme.base.black};
    font-size: 0.9375rem;
    line-height: 1.375rem;
    margin-left: 16px;

    ${breakpoints.md} {
      font-size: 1.125rem;
      line-height: 2rem;
    }

    ${breakpoints.lg} {
      font-size: 1.25rem;
      line-height: 2rem;
    }

    li {
      padding-left: 24px;
      width: 100%;
    }
  }

  ul {
    list-style: none;
    color: ${({
  theme
}) => theme.base.black};
    font-size: 0.9375rem;
    line-height: 1.375rem;
    margin-left: 16px;

    ${breakpoints.md} {
      font-size: 1.125rem;
      line-height: 2rem;
    }

    ${breakpoints.lg} {
      font-size: 1.25rem;
      line-height: 2rem;
    }

    li {
      padding-left: 24px;

      &:before {
        content: '';
        width: 16px;
        height: 4px;
        background-color: ${({
  theme
}) => theme.base.black};
        padding-right: 5px;
        display: inline-block;
        position: relative;
        top: -5px;
        left: -24px;
      }
    }
  }
`;
export default TextStyle;